module.exports = __webpack_public_path__ + "static/media/globe-solid.38f62a6c.svg";